import { CircularProgress } from "@mui/material";

export default function Loading(){
    return <CircularProgress size={50} color="primary"/>
}